import React, { useReducer, useState } from "react";
import "./eleveStyle.scss";
import { Box, Divider, Skeleton, Tooltip } from "@mui/material";
import {
  AccountCircleRounded,
  ArrowBackRounded,
  CancelRounded,
  CheckCircle,
  Person,
  PictureAsPdfRounded,
  Print,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import Delete from "../../../component/dialog/delete/Delete.tsx";
import SearchBar from "../../../component/searchBar/Search.tsx";
import UpdateEleve from "./UpdateEleve.tsx";
// import NewEleve from "./newEleve.tsx";
import SingleEleve from "./singleEleve.tsx";
import { API_CONFIG } from "../../../apiCaller/configuration.Caller.js";
import { accountService } from "../../../_services/accountServices.js";
import {
  classeType,
  EleveType,
  ParentType,
  PromotionType,
  requestType,
  schooYearType,
} from "../../../types/GlobalType.ts";
import { catchErrorApiCall } from "../../../_services/apiUtils.js";
import { API_ELEVE } from "../../../apiCaller/eleve.Caller.js";
import AffecteEleve from "./AffecteEleve.tsx";
import { eleveContext } from "../../../context/AppContext.js";
import { API_PARENT } from "../../../apiCaller/perent.Callerl.js";
import toast from "react-hot-toast";
import { orderBy } from "lodash";
import ConnexionErrorDiv from "../../../component/nodata/ConnexionErrorDiv.js";

const Eleve = () => {
  const navigation = useNavigate();

  const [loadingDeleteBtn, setLoadingDeleteBtn] =
    React.useState<boolean>(false);

  const [openArchiveEleve, setopenArchiveEleve] =
    React.useState<Boolean>(false);

  const [openActivateEleve, setopenActivateEleve] =
    React.useState<Boolean>(false);

  const [itemId, setItemId] = useState<string | number>();

  const [stateReload, dispatchReload] = useReducer((x) => x + 1, 0);
  const [realoadStateTwo, setRealoadStateTwo] = useState(0);

  // const [openNew, setOpenNew] = useState<Boolean>(false);
  const [openSingle, setOpenSingle] = useState<Boolean>(false);
  const [openUpdate, setOpenUpdate] = useState<Boolean>(false);
  const [openAffecte, setOpenAffecte] = useState<boolean>(false);

  const [dataParent, setDataParent] = useState<ParentType[]>([]);
  const [dataClasses, setDataClasses] = useState<classeType[]>([]);
  const [dataSY, setDataSY] = useState<schooYearType[]>([]);
  const [dataEleve, setDataEleve] = useState<EleveType[]>([]);
  const [dataPromotion, setDataPromotion] = useState<PromotionType[]>([]);
  const [singleDataEleve, setsingleDataEleve] = useState<EleveType>();

  const [selectedAnneeValue, setselectedAnneeValue] = useState<string>("");
  const [searchValue, setsearchValue] = useState<string>("");

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });
  const [stateEleve, setStateEleve] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });
  const [statePromotion, setStatePromotion] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const navigate = useNavigate();

  const fetchAllSY = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    API_CONFIG.ANNEE_SCOLAIRE.getAll(token)
      .then((response) => {
        setState({
          isLoading: false,
          errorMessage: null,
          successMessage: null,
        });

        setDataSY(response.data.data);
      })
      .catch((err) => {
        setState({
          isLoading: false,
          successMessage: false,
          errorMessage: false,
        });

        if (err.code === "ERR_NETWORK") {
          return setState({
            isLoading: false,
            successMessage: false,
            errorMessage: "ERR_NETWORK",
          });
        }

        catchErrorApiCall(err);
      });
  };

  const fetchAllClasses = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_CONFIG.CLASSE.getAll(token);
      setDataClasses(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });

      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }

      catchErrorApiCall(error);
    }
  };

  const fetchAllParent = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_PARENT.PARENT.getAll(token);
      setDataParent(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });

      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }

      catchErrorApiCall(error);
    }
  };

  const fetchAllEleve = async () => {
    setStateEleve({
      isLoading: true,
      errorMessage: null,
      successMessage: null,
    });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_ELEVE.ELEVE.getAll(token);
      setDataEleve(response.data.data);

      setStateEleve({ ...state, isLoading: false });
    } catch (error) {
      setStateEleve({ ...state, isLoading: false });

      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }

      catchErrorApiCall(error);
    }
  };

  const fetchAllPromotion = async () => {
    setStatePromotion({
      isLoading: true,
      errorMessage: null,
      successMessage: null,
    });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_ELEVE.PROMOTION.getAll(token);
      setDataPromotion(response.data.data);

      setStatePromotion({ ...state, isLoading: false });
    } catch (error) {
      setStatePromotion({ ...state, isLoading: false });

      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  const handleActivateEleve = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      await API_ELEVE.ELEVE.active(id, token);
      setLoadingDeleteBtn(false);
      setopenActivateEleve(false);
      dispatchReload();
      toast.success("Elève activé avec succes", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);
      catchErrorApiCall(error);
    }
  };

  const handleArchiveEleve = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      let response = await API_ELEVE.ELEVE.desactive(id, token);
      // console.log(response);
      setLoadingDeleteBtn(false);
      setopenArchiveEleve(false);
      dispatchReload();
      toast.success("Elève archivé avec succès", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      // console.log(error);
      setLoadingDeleteBtn(false);
      catchErrorApiCall(error);
    }
  };

  let sortedData: EleveType[] = [];
  if (dataEleve.length > 0) {
    sortedData = orderBy(dataEleve, ["nom"], ["asc"]);
  }

  const dataStatus: {
    total: EleveType[];
    affected: EleveType[];
    noAffected: EleveType[];
    archived: EleveType[];
  } = {
    total: dataEleve,
    affected: [],
    noAffected: [],
    archived: [],
  };

  //eleve affected (data included in promotion for selected year)
  for (let item of sortedData) {
    if (!item.eleve_status) {
      dataStatus.archived.push(item);
    }

    for (let element of dataPromotion) {
      if (
        item.eleve_id === element.eleve_id &&
        selectedAnneeValue.toLowerCase() ===
          element.annee_scolaire_designation?.toLowerCase()
      ) {
        dataStatus.affected.push(item);
      }
    }
  }
  //eleve no affected (data not included in promotion for selected year)
  //look for difference between two array of object(eleveData and dataStatus.affected)
  // 1Trouver les éléments qui ne sont pas communs entre les deux tableaux
  const diff1 = dataEleve.reduce((acc: EleveType[], obj1: EleveType) => {
    if (!dataStatus.affected.some((obj2) => obj2.eleve_id === obj1.eleve_id)) {
      acc.push(obj1);
    }
    return acc;
  }, []);

  const diff2 = dataStatus.affected.reduce(
    (acc: EleveType[], obj2: EleveType) => {
      if (!dataEleve.some((obj1) => obj1.eleve_id === obj2.eleve_id)) {
        acc.push(obj2);
      }
      return acc;
    },
    [],
  );

  const result = [...diff1, ...diff2];
  dataStatus.noAffected = result;

  // -------------------------------------------------
  // ---look for duplicated data in array of object---
  // -------------------------------------------------
  // const groupByName = (array) => {
  //   const grouped = array.reduce((acc, obj) => {
  //     acc[obj.eleve_id] = acc[obj.eleve_id] || [];
  //     acc[obj.eleve_id].push(obj);
  //     return acc;
  //   }, {});

  //   // Filter out groups that have only one element
  //   return Object.values(grouped).filter((group: any) => group.length > 1);
  // };

  // const groupedDuplicates = groupByName(dataPromotion);
  // console.log(groupedDuplicates);
  // -------------------------------------------------

  const skeletonHeader = (
    <div className="configuration_">
      <Skeleton
        variant="rounded"
        height={25}
        width={250}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
      <Skeleton
        variant="rounded"
        height={25}
        width={150}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
    </div>
  );
  const skeletonSearchSection = (
    <>
      <div className="input-container">
        <Skeleton
          variant="rounded"
          height={18}
          width={250}
          sx={{ marginTop: "5px" }}
        />

        <div className="right_list_part">
          <Skeleton
            variant="rounded"
            height={18}
            width={"90%"}
            sx={{ marginTop: "5px" }}
          />
          <Skeleton
            variant="circular"
            height={18}
            width={18}
            sx={{ marginTop: "5px" }}
          />
        </div>
      </div>
      <div className="stateData">
        <Skeleton
          variant="rounded"
          height={15}
          width={40}
          sx={{ marginTop: "5px" }}
        />
        <Skeleton
          variant="rounded"
          height={15}
          width={40}
          sx={{ marginTop: "5px" }}
        />
        <Skeleton
          variant="rounded"
          height={15}
          width={40}
          sx={{ marginTop: "5px" }}
        />
        <Skeleton
          variant="rounded"
          height={15}
          width={40}
          sx={{ marginTop: "5px" }}
        />
      </div>
    </>
  );
  const skeletonTable = (
    <Skeleton
      sx={{ marginTop: "10px" }}
      variant="rounded"
      height={500}
      width={"100%"}
    />
  );

  React.useEffect(() => {
    fetchAllSY();
    fetchAllEleve();
    fetchAllParent();
    fetchAllClasses();
    fetchAllPromotion();
  }, [stateReload, realoadStateTwo]);

  return (
    <>
      {state.errorMessage === "ERR_NETWORK" ||
      stateEleve.errorMessage === "ERR_NETWORK" ||
      statePromotion.errorMessage === "ERR_NETWORK" ? (
        <ConnexionErrorDiv />
      ) : (
        <Box
          bgcolor="#eee"
          flex={5}
          p={1}
          sx={{ marginLeft: "200px", marginTop: "66px" }}
        >
          {state.isLoading ? (
            skeletonHeader
          ) : (
            <div className="configuration_">
              <div className="homeMenuCong">
                {/* <Link to="/" style={{ marginTop: "5px" }}> */}
                <ArrowBackRounded
                  sx={{
                    color: "#0091EA",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    mt: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => navigation("/configuration/configuration")}
                />
                {/* </Link> */}
                <div className="homeTitleItem">
                  <span className="homeTitle"> Configuration</span>
                </div>
                <div className="homeTitleItem">
                  <Person sx={{ color: "#1565C0", mr: "10px" }} />
                  <span className="homeTitleSmall">Elève </span>
                </div>
              </div>
              <div className="right__">
                {/* <button
              className="add_button_pers"
              onClick={() => setOpenNew(true)}
            >
              <Tooltip title="Nouveau élève">
                <PersonAddAlt1 className="ico" />
              </Tooltip>
              Nouveau
            </button> */}
                <button className="add_button_pers">
                  <Tooltip title="Exporter PDF">
                    <PictureAsPdfRounded className="ico" />
                  </Tooltip>
                  exporter
                </button>
              </div>
            </div>
          )}

          <Divider sx={{ marginTop: "5px", marginBottom: "10px" }} />

          <div className="card_Classe">
            {state.isLoading ? (
              skeletonSearchSection
            ) : (
              <>
                {" "}
                <div className="input-container">
                  <div className="leftTitle">
                    <h2 className="card-title">Liste</h2>
                    <select
                      value={selectedAnneeValue}
                      onChange={(e) => setselectedAnneeValue(e.target.value)}
                      className="selectClasse"
                    >
                      <option value="">-- Selectionner année --</option>
                      {dataSY.map((value, index) => {
                        return (
                          <option
                            key={index}
                            value={value.annee_scolaire_designation}
                          >
                            {value.annee_scolaire_designation.toUpperCase()}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="right_list_part">
                    <SearchBar
                      searchValue={searchValue}
                      setSearchValue={setsearchValue}
                      label="Rechercher..."
                    />
                    <button className="add_button_pers">
                      <Tooltip title="Imprimer">
                        <Print className="ico" />
                      </Tooltip>
                    </button>
                  </div>
                </div>
                <div className="stateData">
                  <span className="total">Total {dataEleve.length}</span>
                  <span className="non_affected">
                    Archivé {dataStatus.archived.length}
                  </span>
                  {/* <span className="total">Inscrit {dataStatus.affected}</span> */}
                  <span className="affected">
                    Affecté {dataStatus.affected.length}
                  </span>
                  <span className="non_affected">
                    Non affecté {dataStatus.noAffected.length}
                  </span>
                </div>
              </>
            )}

            {stateEleve.isLoading || statePromotion.isLoading ? (
              skeletonTable
            ) : (
              <div className="table_componentEl" role="region">
                <table>
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Noms</th>
                      <th>Année scolaire</th>
                      <th>Classe</th>
                      <th className="headerSection">Status</th>
                      <th className="headerSection">Affecté</th>
                      <th className="actionHeader"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedData
                      .filter(
                        (value) =>
                          value.nom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.postnom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.prenom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.classe_designation
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()),
                      )
                      .map((item, index) => {
                        let promotionClasse: string | undefined = "";
                        let promotionId: number | undefined = undefined;
                        // let promotionAnneeId: number | undefined = undefined;

                        for (const element of dataPromotion) {
                          if (
                            item.eleve_id === element.eleve_id &&
                            selectedAnneeValue.toLowerCase() ===
                              element.annee_scolaire_designation?.toLowerCase()
                          ) {
                            promotionId = element.promotion_id;
                            promotionClasse = element.classe_designation;
                          }
                        }
                        let ownerParent: ParentType;
                        for (const element of dataParent) {
                          if (element.parent_id === item.parent_id) {
                            ownerParent = element;
                          }
                        }

                        return (
                          <tr key={index}>
                            <td
                              onClick={() => {
                                setsingleDataEleve({
                                  ...item,
                                  parentNom: ownerParent.nom,
                                  parentPrenom: ownerParent.postnom,
                                  parentPostNom: ownerParent.prenom,
                                  parentSexe: ownerParent.sexe,
                                  parentPhone: ownerParent.telephone,
                                  parentVille: ownerParent.ville,
                                  parentCommune: ownerParent.commune,
                                  parentQuartier: ownerParent.quartier,
                                  parentAvenue: ownerParent.avenue,
                                });
                                setOpenSingle(true);
                              }}
                            >
                              {index + 1}
                            </td>
                            <td
                              onClick={() => {
                                setsingleDataEleve({
                                  ...item,
                                  parentNom: ownerParent.nom,
                                  parentPrenom: ownerParent.postnom,
                                  parentPostNom: ownerParent.prenom,
                                  parentSexe: ownerParent.sexe,
                                  parentPhone: ownerParent.telephone,
                                  parentVille: ownerParent.ville,
                                  parentCommune: ownerParent.commune,
                                  parentQuartier: ownerParent.quartier,
                                  parentAvenue: ownerParent.avenue,
                                });
                                setOpenSingle(true);
                              }}
                            >
                              <div className="userName">
                                <AccountCircleRounded />
                                {`${item.nom?.toUpperCase()} ${item.postnom?.toUpperCase()} ${item.prenom?.toUpperCase()}`}
                              </div>
                            </td>
                            <td
                              onClick={() => {
                                setsingleDataEleve({
                                  ...item,
                                  parentNom: ownerParent.nom,
                                  parentPrenom: ownerParent.postnom,
                                  parentPostNom: ownerParent.prenom,
                                  parentSexe: ownerParent.sexe,
                                  parentPhone: ownerParent.telephone,
                                  parentVille: ownerParent.ville,
                                  parentCommune: ownerParent.commune,
                                  parentQuartier: ownerParent.quartier,
                                  parentAvenue: ownerParent.avenue,
                                });
                                setOpenSingle(true);
                              }}
                            >
                              {selectedAnneeValue
                                ? selectedAnneeValue
                                : "--------"}
                            </td>
                            <td
                              onClick={() => {
                                setsingleDataEleve({
                                  ...item,
                                  parentNom: ownerParent.nom,
                                  parentPrenom: ownerParent.postnom,
                                  parentPostNom: ownerParent.prenom,
                                  parentSexe: ownerParent.sexe,
                                  parentPhone: ownerParent.telephone,
                                  parentVille: ownerParent.ville,
                                  parentCommune: ownerParent.commune,
                                  parentQuartier: ownerParent.quartier,
                                  parentAvenue: ownerParent.avenue,
                                });
                                setOpenSingle(true);
                              }}
                            >
                              {promotionClasse
                                ? promotionClasse?.toUpperCase()
                                : "--------"}
                            </td>

                            <td className="statusSection">
                              <span>
                                {item.eleve_status ? (
                                  <Tooltip title="Activé" placement="left">
                                    <CheckCircle
                                      style={{
                                        color: "#28a745",
                                        fontSize: "14px",
                                      }}
                                    />
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Archivé" placement="left">
                                    <CancelRounded
                                      style={{
                                        color: "#7f1d18",
                                        fontSize: "14px",
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </span>
                            </td>
                            <td className="statusSection">
                              <span>
                                {promotionClasse ? (
                                  <Tooltip title="Activé" placement="left">
                                    <CheckCircle
                                      style={{
                                        color: "#28a745",
                                        fontSize: "14px",
                                      }}
                                    />
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Archivé" placement="left">
                                    <CancelRounded
                                      style={{
                                        color: "#7f1d18",
                                        fontSize: "14px",
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </span>
                            </td>
                            <td>
                              <div className="actionSection">
                                {item.eleve_status ? (
                                  <span
                                    className="archiveP"
                                    onClick={() => {
                                      setItemId(item.eleve_id);
                                      setopenArchiveEleve(true);
                                    }}
                                  >
                                    Archiver
                                  </span>
                                ) : (
                                  <span
                                    className="archiveP"
                                    onClick={() => {
                                      setItemId(item.eleve_id);
                                      setopenActivateEleve(true);
                                    }}
                                  >
                                    Activer
                                  </span>
                                )}

                                <span
                                  className="editP"
                                  onClick={() => {
                                    setsingleDataEleve({
                                      ...item,
                                      parentNom: ownerParent.nom,
                                      parentPrenom: ownerParent.postnom,
                                      parentPostNom: ownerParent.prenom,
                                      parentSexe: ownerParent.sexe,
                                      parentPhone: ownerParent.telephone,
                                      parentVille: ownerParent.ville,
                                      parentCommune: ownerParent.commune,
                                      parentQuartier: ownerParent.quartier,
                                      parentAvenue: ownerParent.avenue,
                                      promotionId: promotionId,
                                      // promotionAnneeId: promotionAnneeId,
                                      promotionClasse: promotionClasse,
                                    });
                                    setOpenUpdate(true);
                                  }}
                                >
                                  Editer
                                </span>
                                {!promotionClasse && selectedAnneeValue ? (
                                  <span
                                    className="more"
                                    onClick={() => {
                                      setsingleDataEleve(item);
                                      setOpenAffecte(true);
                                    }}
                                  >
                                    Affecter
                                  </span>
                                ) : (
                                  <span className="moreDisabled">Affecter</span>
                                )}

                                {/* <IconButton onClick={handleClick}>
                              <MoreVertOutlined
                                className="ico"
                                onClick={() => {
                                  setItemId(item.eleve_id);
                                }}
                              />
                            </IconButton>
                            {item.eleve_status ? (
                              <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                PaperProps={{
                                  style: {
                                    width: "14ch",
                                  },
                                }}
                              >
                                <MenuItem
                                  onClick={() => {
                                    handleClose();
                                    setopenArchiveEleve(true);
                                  }}
                                  sx={{ fontSize: 12, fontWeight: "" }}
                                >
                                  Archiver{item.eleve_status}
                                </MenuItem>

                                <MenuItem
                                  onClick={() => {
                                    handleClose();
                                    setOpenUpdate(true);
                                  }}
                                  sx={{ fontSize: 12, fontWeight: "" }}
                                >
                                  Modifier
                                </MenuItem>
                                <MenuItem
                                  onClick={() => {
                                    handleClose();
                                    setOpenUpdate(true);
                                  }}
                                  sx={{ fontSize: 12, fontWeight: "" }}
                                >
                                  Affecter
                                </MenuItem>
                              </Menu>
                            ) : (
                              <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                PaperProps={{
                                  style: {
                                    width: "14ch",
                                  },
                                }}
                              >
                                <MenuItem
                                  onClick={() => {
                                    handleClose();
                                    setopenActivateEleve(true);
                                  }}
                                  sx={{ fontSize: 12, fontWeight: "" }}
                                >
                                  Activer{item.eleve_status}
                                </MenuItem>

                                <MenuItem
                                  onClick={() => {
                                    handleClose();
                                    setOpenUpdate(true);
                                  }}
                                  sx={{ fontSize: 12, fontWeight: "" }}
                                >
                                  Modifier
                                </MenuItem>
                                <MenuItem
                                  onClick={() => {
                                    handleClose();
                                    setOpenUpdate(true);
                                  }}
                                  sx={{ fontSize: 12, fontWeight: "" }}
                                >
                                  Affecter
                                </MenuItem>
                              </Menu>
                            )} */}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </Box>
      )}

      {openUpdate && (
        <UpdateEleve
          setOpen={setOpenUpdate}
          data={singleDataEleve}
          dataParent={dataParent}
          dataClasse={dataClasses}
          dispatchReload={dispatchReload}
          currentYear={selectedAnneeValue}
          dataYear={dataSY}
        />
      )}
      {openAffecte && (
        <AffecteEleve
          setOpen={setOpenAffecte}
          data={singleDataEleve}
          currentYear={selectedAnneeValue}
          dataClasse={dataClasses}
          dataYear={dataSY}
          dispatchReload={dispatchReload}
        />
      )}
      {/* {openNew && <NewEleve setOpen={setOpenNew} />} */}
      {openSingle && (
        <eleveContext.Provider value={singleDataEleve}>
          <SingleEleve setOpen={setOpenSingle} setReload={setRealoadStateTwo} />
        </eleveContext.Provider>
      )}

      {openActivateEleve && (
        <Delete
          setOpen={setopenActivateEleve}
          itemId={itemId}
          label={"Voulez-vous vraiment activer ce élève?"}
          handleDelete={handleActivateEleve}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Activation"
        />
      )}
      {openArchiveEleve && (
        <Delete
          setOpen={setopenArchiveEleve}
          itemId={itemId}
          label={"Voulez-vous vraiment archiver ce élève?"}
          handleDelete={handleArchiveEleve}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Archivage"
        />
      )}
    </>
  );
};

export default Eleve;
